/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { A11yModule } from '@angular/cdk/a11y';
import { MatCommonModule } from '@angular/material/core';
import { MatDialog, MAT_DIALOG_SCROLL_STRATEGY_PROVIDER } from './dialog';
import { MatDialogContainer } from './dialog-container';
import { MatDialogClose, MatDialogContent, MatDialogTitle, MatDialogActions } from './dialog-content-directives';
var MatDialogModule = (function () {
    function MatDialogModule() {
    }
    MatDialogModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        OverlayModule,
                        PortalModule,
                        A11yModule,
                        MatCommonModule,
                    ],
                    exports: [
                        MatDialogContainer,
                        MatDialogClose,
                        MatDialogTitle,
                        MatDialogContent,
                        MatDialogActions,
                        MatCommonModule,
                    ],
                    declarations: [
                        MatDialogContainer,
                        MatDialogClose,
                        MatDialogTitle,
                        MatDialogActions,
                        MatDialogContent,
                    ],
                    providers: [
                        MatDialog,
                        MAT_DIALOG_SCROLL_STRATEGY_PROVIDER,
                    ],
                    entryComponents: [MatDialogContainer],
                },] },
    ];
    /**
     * @nocollapse
     */
    MatDialogModule.ctorParameters = function () { return []; };
    return MatDialogModule;
}());
export { MatDialogModule };
function MatDialogModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatDialogModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatDialogModule.ctorParameters;
}
//# sourceMappingURL=dialog-module.js.map